<template>
  <el-card class="box-card mb-50" id="contactSendMail">
    <el-row>
      <el-col :span="24">
        <el-form :rules="rules" :model="inputForm" ref="inputForm" id="form" :action="urls.change" method="post">
          <div class="group-input mt-0"><span>{{ $t('contacts.mail.verify.group_current_input') }}</span></div>

          <el-form-item prop="code" :error="getErrorForField('code', errors)">
            <el-input :placeholder="$t('contacts.mail.verify.placeholder')" v-model="inputForm.code" name="code" type="text"/>
          </el-form-item>
          <input type="hidden" name="_token" :value="csrf">
          <div class="form-footer">
            <el-button class="btn-reset" @click="reset('inputForm')">{{ $t('contacts.mail.verify.btn') }}</el-button>
            <el-button class="is-text" :disabled="disabled" @click="handleResendCode" type="primary" link >{{ $t('contacts.mail.verify.btn_resend') }}</el-button>
          </div>
        </el-form>
       </el-col>
    </el-row>
    <div class="contact-mail-verify-box">
      <div class="contact-mail-verify-box-child">
        <p class="noti-main-title">
          <img class="note-icon" src="/images/icons8-note.svg" /><span>メールが届かない場合</span>
        </p>
        <div class="noti-main-content">
          <p>
            （1）迷惑メールフォルダ内にメールが届いていないかご確認ください。<br>
            （2）メールアドレスが誤っていた場合は、お手数ですが<el-link type="primary" :href="redirectPage()" class="link-contact" :underline="false">こちら</el-link>より再度メールアドレスのご入力をお願いします。
          </p>
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
  import { ElNotification } from 'element-plus';
import { resendCode } from '../../../api/contact'
  export default {
    props: {
      errors: { type: Object, required: false },
      urls: { type: Object, required: false, default: {} },
      partnerResetCode: { type: Object, required: false, default: {} },
      role: { type: Number, required: true, default: true },
    },
    data() {
      return {
        inputForm: {
          code: "",
        },
        disabled: false,
        rules: {
          code: [
            { required: true, message: this.$t('errors.required', [this.$t('code')]), trigger: 'blur' },
            { max: 6, message: this.$t('errors.max', [this.$t('code'), 6]), trigger: 'blur' },
          ],
        },
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      }
    },
    methods: {
      reset(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const form = document.getElementById("form");
            form.submit();
          } else {
            return false;
          }
        });
      },

      handleResendCode() {
        this.disabled = true
        resendCode(this.partnerResetCode, this.role)
        .then(response => response.json())
        .then(response => {
          this.disabled = false
          if (response.status_code === 200) {
            ElNotification({
              message: response.data,
              type: 'success',
            })
          }
        })
      },

      redirectPage() {
        const url = new URL(window.location.href)
        if (url.pathname.includes('change-mail')) {
          if (this.role == this.$userRole.partner.staff) {
            return `/my-page/change-mail`
          }
          return `/staff/${this.partnerResetCode.staff_id}/change-mail`
        }
        return '/contacts/mail'
      },

      isErrorForField(field, errors) {
        return !(errors == null || errors.length == 0 || !errors.hasOwnProperty(field));
      },

      getErrorForField(field, errors) {
        return this.isErrorForField(field, errors) ? errors[field][0] : '';
      },
    },
  }
</script>

<style lang="scss">
  #contactSendMail {
    min-height: 560px;
    .el-form {
      width: 100%;
      .el-input {
        width: 454px;
        height: 45px;
      }
      .el-form-item__content {
        margin-top: 20px;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
      }
      .el-form-item__label {
        width: 100%;
        text-align: left;
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        color: #000000;
        justify-content: flex-start;
        font-weight: 700;
      }
      .text-danger {
        white-space: pre-line;
        color: #AC3B29;
        font-size: 13px;
        letter-spacing: 1.3px;
        line-height: 21px;
        margin-bottom: 8px;
      }
    }
  }
  .contact-mail-verify-box{
    max-width: 630px;
    margin-top: 35px;
    box-sizing: border-box;
    .contact-mail-verify-box-child {
      background: #F7F3ED 0% 0% no-repeat padding-box;
      opacity: 1;
      height: 260px;
    }

    .noti-main-title {
      font: normal normal normal 15px/21px Alternate Gothic No2 D;
      letter-spacing: 0.75px;
      color: #000000;
      opacity: 1;
      padding-top: 30px;
      text-align: center;
    }

    .noti-main-content {
      width: 90%;
      margin: 20px auto 32px;
      text-align: left;
      font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
      letter-spacing: 0.65px;
      color: #000000;
    }
  }
  .note-icon {
    width: 27px;
    height: 27px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 2px;
    margin-bottom: 5px;
  }

  .link-contact {
    color: #3671A3 !important;
    --el-link-hover-text-color: #3671A3 !important;
    vertical-align: baseline !important;
    font-size: 13px;
  }
</style>
